import { Flex, Pagination, Typography } from "antd"

const { Text } = Typography

const MobilePagination = ({ current, total, pageSize, onChange }) => {
  if (!total || pageSize >= total) return null

  const from = (current - 1) * pageSize + 1
  const to = Math.min(current * pageSize, total)

  return (
    <Flex vertical align="center" gap={8} style={{ marginTop: 16, paddingBottom: 80 }}>
      <Text type="secondary">
        <Text strong>{`${from}–${to}`}</Text>
        {` of ${total}`}
      </Text>
      <Pagination
        current={current}
        total={total}
        pageSize={pageSize}
        onChange={onChange}
        showSizeChanger={false}
        showLessItems={true}
      />
    </Flex>
  )
}

export default MobilePagination
